(function ($) {
  "use strict";
  $(function () {
      // Termékek szekció
      var termekekSwiper = new Swiper(".uj_termekekSection .swiper-container", {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: false,
          pagination: {
              el: ".uj_termekekSection .swiper-pagination",
              clickable: true,
          },
          navigation: {
              nextEl: ".uj_termekekSection .swiper-button-next",
              prevEl: ".uj_termekekSection .swiper-button-prev",
          },
          breakpoints: {
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 4 },
          },
      });

      // Akciós termékek szekció
      var akcioSwiper = new Swiper(".swiper_termekekSection_akcio .swiper-container", {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: false,
          pagination: {
              el: ".swiper_termekekSection_akcio .swiper-pagination",
              clickable: true,
          },
          navigation: {
              nextEl: ".swiper_termekekSection_akcio .swiper-button-next",
              prevEl: ".swiper_termekekSection_akcio .swiper-button-prev",
          },
          breakpoints: {
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 4 },
          },
      });

      var ajanlott = new Swiper(".ajanlott .swiper-container", {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        
        navigation: {
            nextEl: ".ajanlott .swiper-button-next",
            prevEl: ".ajanlott .swiper-button-prev",
        },
        breakpoints: {
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 4 },
        },
    });
    var kapcsolodo = new Swiper(".kapcsolodo .swiper-container", {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        
        navigation: {
            nextEl: ".kapcsolodo .swiper-button-next",
            prevEl: ".kapcsolodo .swiper-button-prev",
        },
        breakpoints: {
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 4 },
        },
    });
      
      
      var legnepszerubb_termekekSection = new Swiper(".legnepszerubb_termekekSection .swiper-container", {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        pagination: {
            el: ".legnepszerubb_termekekSection .swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".legnepszerubb_termekekSection .swiper-button-next",
            prevEl: ".legnepszerubb_termekekSection .swiper-button-prev",
        },
        breakpoints: {
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 4 },
        },
    });

      // Blog szekció
      var blogSwiper = new Swiper(".blog_sliderSection .swiper-container", {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: false,
          pagination: {
              el: ".blog_sliderSection .swiper-pagination",
              clickable: true,
          },
          navigation: {
              nextEl: ".blog_sliderSection .swiper-button-next",
              prevEl: ".blog_sliderSection .swiper-button-prev",
          },
          breakpoints: {
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 4 },
          },
      });

      // Hős szekció
      var heroSwiper = new Swiper(".heroSection .swiper-container", {
          slidesPerView: 1,
          loop: false,
          pagination: {
              el: ".heroSection .swiper-pagination",
              clickable: true,
          },
          navigation: {
              nextEl: ".heroSection .swiper-button-next",
              prevEl: ".heroSection .swiper-button-prev",
          },
      });
  });
})(jQuery);
